import React from 'react';
import * as Styled from './styled';

const Separator = () => (
  <div className="container">
    <Styled.Border />
  </div>
);
export default Separator;
